
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.75 5.25V.75h-4.5","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M21.75.75 16.7 5.8a2.24 2.24 0 0 1-2.24.56L8.75 4.84a2.24 2.24 0 0 0-2.17.58L.75 11.25m0 12h22.5M6 16.75H3a.76.76 0 0 0-.75.75v5.75h4.5V17.5a.76.76 0 0 0-.75-.75Zm7.5-6.5h-3a.76.76 0 0 0-.75.75v12.25h4.5V11a.76.76 0 0 0-.75-.75Zm7.5 3.5h-3a.76.76 0 0 0-.75.75v8.75h4.5V14.5a.76.76 0 0 0-.75-.75Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    